<section class="bg-white p-5">
  <h1 class="text-xl font-bold mb-6 text-dc-navy border-b border-gray-300 pb-3">
    {{ "CONTACT_US.TITLE" | translate }}
  </h1>

  <form [formGroup]="form" class="space-y-8 w-full lg:w-5/9">
    <div class="">
      <div class="field-control">
        <!-- Name -->
        <app-text-field
          [control]="form.get('name')"
          [label]="'CONTACT_US.NAME' | translate"
        />
      </div>

      <!-- Email -->
      <div class="field-control">
        <app-text-field
          [control]="form.get('email')"
          [label]="'CONTACT_US.EMAIL' | translate"
        />
      </div>

      <!-- Phone number -->
      <div class="field-control">
        <app-mobile-number
          [control]="form.get('mobile')"
          [label]="'CONTACT_US.PHONE' | translate"
          [countryCodeControl]="form.get('countryCode')"
          [validationMessages]="{
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
            uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
          }"
        />
      </div>

      <!-- Category dropdown -->
      <div class="field-control">
        <app-option-field
          [control]="form.get('category')"
          [label]="'CONTACT_US.CATEGORY' | translate"
          [lovType]="lookupKey.DC_CONTACT_CATEGORY"
          [labelKey]="'Value'"
          [valueKey]="'Value'"
        ></app-option-field>
      </div>
      <!-- Message textarea (use multiline prop or textarea mode of your component) -->
      <div class="field-control">
        <app-text-field
          [control]="form.get('message')"
          [label]="'CONTACT_US.MESSAGE' | translate"
          type="big-text"
          [maxlength]="1000"
          rows="6"
        />
      </div>
      <!-- Submit button -->
      <app-button
        type="button"
        [label]="
          isSubmitting
            ? ('PLEASE_WAIT' | translate)
            : ('BUTTONS.SUBMIT' | translate)
        "
        [classesName]="'btn-width-auto'"
        [disabled]="isSubmitting"
        (onBtnClick)="submit()"
      ></app-button>
    </div>
  </form>
</section>
